import httpAuth from '../../services/httpAuth'
import httpNotAuth from '../../services/httpNotAuth'

import { getMenuTopError, getMenuTopSuccess } from './menuTop.slice'

export const requestMenuTop = (data) => async (dispatch, getState) => {
  const checkAuth = getState()?.auth

  if (checkAuth) {
    try {
      const response = await httpAuth.post(`/sport/getSports`)

      if (response?.data?.status) {
        let res = response?.data?.data
        dispatch(getMenuTopSuccess(res))
      }
      return response
    } catch (e) {
      dispatch(getMenuTopError())
    }
  } else {
    try {
      const response = await httpAuth.post(`/sport/sports`)

      if (response?.data?.status) {
        let res = response?.data?.data
        dispatch(getMenuTopSuccess(res))
      }
      return response
    } catch (e) {
      dispatch(getMenuTopError())
    }
  }
}
